import React, { useState, useEffect, useLayoutEffect } from 'react';
import axios from 'axios';
import t from "../../Utils/Translation";
import {
	AUTHORIZED_URL_PREFIX,
    PLAYLISTS_URL,
	AxiosConfig
} from '../../Utils/Constants';
import Loading from '../common/Loading';
import Units from '../home/Units';
import { notify, pleaseRefreshError } from '../../Utils/Notificator';
import HelpOutlineSharpIcon from '@mui/icons-material/HelpOutlineSharp';
import { Tooltip } from '@mui/material';
import friendlyDate from '../../Utils/FriendlyDate';
import Footer from './../common/Footer';


const Playlists = () => {
	const [ units, setUnits ] = useState([]);
	const [playlists, setPlaylists] = useState([]);
	const [playlistsAssignedToMe, setPlaylistsAssignedToMe] = useState([])
	const [ isLoading, setIsLoading ] = useState(true);
	const ref = React.createRef();
	const [ pageScrolling, setPageScrolling] = useState(false);

	const handleScreenSize = () => {
		if (ref.current.clientHeight < ref.current.scrollHeight) {
			setPageScrolling(true);
		  } else {
			  setPageScrolling(false);
		  }
	}

	useLayoutEffect(() => {
		handleScreenSize();
		window.addEventListener('resize', handleScreenSize);
		return () => {
			window.removeEventListener('resize', handleScreenSize);
		}
	}, [ref]);

	useEffect(() => {
		const fetchPlaylists = async () => {
			try {
				const { data } = await axios.get(`${AUTHORIZED_URL_PREFIX}${PLAYLISTS_URL}`, AxiosConfig());
				setUnits(data.units);
				let filteredAssignedPlaylists = data.playlistsAssignedToMe;
				for (let i = 0; i < data.playlistsAssignedToMe.length; i++) {
					for (let j = 0; j < data.playlists.length; j++) {
						data.playlistsAssignedToMe[i]._id===data.playlists[j]._id && (filteredAssignedPlaylists=filteredAssignedPlaylists.filter(playlist => playlist._id!==data.playlistsAssignedToMe[i]._id));
					}

				}
				setPlaylists(data.playlists);
				setPlaylistsAssignedToMe(filteredAssignedPlaylists);
				setIsLoading(false);
				if (!data.success) {
					notify(pleaseRefreshError);
				}
			} catch (error) {
				console.log(error);
				notify(pleaseRefreshError);
			}
		};
		fetchPlaylists();
	}, []);

	return (
		<div ref={ref} className="lykioccs-main-content lykiocss-category-bg lykiocss-hide-footer">
			{isLoading ? (
				<Loading />
			) : (
				<div>
					<React.Fragment>
					
					{playlists.map(playlist => {
						return <React.Fragment>
							<div className="lykiocss-stories-title">
								<h1>{playlist.name}</h1>
							</div>
							<div>
							<Units units={playlist.units} hideTitle={true}/>
							</div>
						</React.Fragment>
					})}

					{playlistsAssignedToMe.map(playlist => {
						return <React.Fragment>
							<div className="lykiocss-stories-title">
								<h1>{playlist.name}</h1><span>
									<Tooltip title={playlist.deadline ? `assigned to me by ${playlist.creator.firstname} ${playlist.creator.lastname}. Must be completed by ${friendlyDate(new Date(playlist.deadline))}.` : `assigned to me by ${playlist.creator.firstname} ${playlist.creator.lastname}.`}>
              							<div><HelpOutlineSharpIcon/></div>
              						</Tooltip>
									  </span>
							</div>
							<div>
							<Units units={playlist.units} hideTitle={true}/>
							</div>
						</React.Fragment>
					})}

					<div className="lykiocss-stories-title">
						<h1>{t('Favourites')}</h1>
					</div>		
					{units.length < 1 ? (
						<div className='lykiocss-center'>{t('No favourites yet, add something!')}</div>
					) : (
						<div>
							<Units units={units} hideTitle={true} title={t('My Favourites')} />
						</div>
					)}
					</React.Fragment>		
					</div>
			)}
			<div style = { !pageScrolling ? { position:'fixed', bottom:'0' } : {position:'relative'}}>
			<Footer />
			</div>
		</div>
	);
};

export default Playlists;
